import styled, {css} from 'styled-components';

import {bottomDashedLineCss} from '~components/atoms/DashedLine/styles';
import {H6, TextSmall} from '~components/atoms/Text';

import {PlotImageWrapper} from '../PlotPreview/PlotImage/styles';

export const Wrapper = styled.a`
    position: relative;
    width: 100%;
    max-width: 354px;
    height: 416px;
    background-color: #ffffff;
    border-radius: 24px;
    padding: 71px 24px 32px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.05);
    transition: box-shadow ease-in-out 600ms;
    cursor: pointer;

    .details {
        opacity: 0;
        transition: all ease-in-out 0.4s;
    }

    &:hover {
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.13);

        ${PlotImageWrapper} {
            transition-duration: 1000ms;
            transform: translateY(-5px);
        }

        .details {
            opacity: 1;
        }
    }

    ${PlotImageWrapper} {
        animation: none;
        transition: transform ease-in-out 600ms;
    }
`;

export const LandTitle = styled(H6)`
    margin: 16px 0 0;
    padding: 8px 0;
`;

type PriceTextProps = {
    active: boolean;
};
export const PriceText = styled(H6)<PriceTextProps>`
    margin: 0 8px 0 8px;
    ${({active}) =>
        !active &&
        css`
            opacity: 0.5;
        `};
`;

export const PriceContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 2px 0 10px 0;
    ${bottomDashedLineCss};
    margin-bottom: 17px;
`;

export const Price = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Subtext = styled(TextSmall)`
    color: rgba(0, 0, 0, 0.5);
`;

export const LoaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
